import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#0F172A",
  },
}));
